module.exports = "<div class=\"container\" fxLayout=\"row\">\n  <div class=\"footer-container\">\n    Powered By My Easy Prop LLC\n  </div>\n</div>"